import { ASSISTANT_ATTENTION_BADGE_MAXIMUM } from '@/constants/assistant';

interface AssistantAttentionBadgeProps {
  count: number;
}

export function AssistantAttentionBadge({ count }: AssistantAttentionBadgeProps) {
  const visibleCount =
    count > ASSISTANT_ATTENTION_BADGE_MAXIMUM ? `${ASSISTANT_ATTENTION_BADGE_MAXIMUM}+` : count;
  return (
    <span aria-hidden="true" className="absolute -top-2 -right-2 flex h-[18px] min-w-[18px]">
      <span className="absolute inline-flex h-full w-full rounded-full bg-zooprimary opacity-60 motion-safe:animate-ping" />
      <span
        data-testid="assistant-attention-badge"
        className="relative inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-zooprimary px-1 text-[10px] font-bold text-zoowhite ring-2 ring-zoowhite"
      >
        {visibleCount}
      </span>
    </span>
  );
}
